export default __webpack_public_path__ + "images/79fcaf3cb136130d6e3fa8315e29f78a-bg-pattern.webp";